import { ReactNode, useEffect } from 'react';
import RioNotification from '@rio-cloud/rio-uikit/Notification';
import { notifyDismissible } from './showNotification';

type EntityUpdateNotificationProps = {
  type?: keyof typeof RioNotification;
  showNotification: boolean;
  message: ReactNode;
  onClose?: () => void;
};

export const useEntityUpdateNotification = ({
  showNotification,
  message,
  type = 'info',
  onClose = () => {},
}: EntityUpdateNotificationProps) => {
  useEffect(() => {
    if (showNotification) {
      notifyDismissible(type, message);
      onClose();
    }
  }, [showNotification]);
};
